var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import ProgressContainer from '../progress/Progress';
import { Dropzone } from '../';
import { FormControl, makeStyles, createStyles, FormHelperText, TextField } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useIntl } from 'react-intl';
const useStyles = makeStyles((theme) => createStyles({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    selectEmpty: {
        marginTop: theme.spacing(2)
    },
    row: {
        display: "flex",
        alignItems: "center",
        paddingTop: "0.5rem"
    },
    fileName: {
        paddingRight: "0.5rem"
    }
}));
const FILE_CATEGORIES = [
    { value: 'Choose', label: 'Välj en kategori' },
    { value: 'CV', label: 'CV' },
    { value: 'InternationalReport', label: 'Internationell bakgrundskontroll' },
    { value: 'Personalia', label: 'Personalia' },
    { value: 'Economi', label: 'Ekonomi' },
    { value: 'CorporateEngagements', label: 'Bolagskartläggning' },
    { value: 'Legal', label: 'Juridik' },
    { value: 'MediaVerification', label: 'Mediakontroll' },
    { value: 'BKOfPartner', label: 'Bakgrundskontroll av partner' },
    { value: 'Other', label: 'Övrig' }
];
const Upload = observer(({ companyId, userId, value: fileIDs, onChange, network, submitError, useFileCategorySelector, orderId }) => {
    const [state, setState] = useState({
        fileIDs: fileIDs,
        files: [],
        uploading: false,
        uploadProgress: {},
        successfullUploaded: false,
        mapper: {},
        fileCategory: 'Choose',
        error: submitError
    });
    const [fieldValue, setFieldValue] = useState({
        hasError: false,
    });
    const intl = useIntl();
    //Triggers when state.files is updated by setState
    useEffect(() => {
        if (state.files.some(f => !Object.keys(state.mapper).includes(f.name))) {
            uploadFiles();
        }
    }, [state.files]);
    const onFilesAdded = files => {
        files = files.filter(file => {
            if (Object.keys(state.uploadProgress).includes(file.name)) {
                return false;
            }
            return true;
        });
        setState(prevState => (Object.assign(Object.assign({}, prevState), { files: [...prevState.files, ...files] })));
    };
    const onFileAdded = (filename, fileId) => {
        state.mapper[filename] = fileId;
        const newFiles = [...state.fileIDs, fileId];
        setState(prevState => (Object.assign(Object.assign({}, prevState), { fileIDs: newFiles, mapper: Object.assign({}, state.mapper) })));
        onChange(fileId);
    };
    const deleteFile = (fileName) => __awaiter(void 0, void 0, void 0, function* () {
        //Remove file from UI
        const updatedFiles = state.files.filter(x => x.name !== fileName);
        const copy = Object.assign({}, state.mapper);
        const updatedFileIDs = state.fileIDs.filter(x => x !== copy[fileName]);
        const fileId = copy[fileName];
        delete copy[fileName];
        const updateProgress = Object.assign({}, state.uploadProgress);
        delete updateProgress[fileName];
        setState(prevState => (Object.assign(Object.assign({}, prevState), { files: updatedFiles, mapper: copy, uploadProgress: updateProgress, fileIDs: updatedFileIDs })));
        //delete the fileID from parent component
        onChange(fileId, true);
        //delete the file from the server
        yield network.deleteFile(fileId);
    });
    const done = filename => {
        const copy = state.uploadProgress;
        copy[filename] = { state: 'done', percentage: 100 };
        setState(prevState => (Object.assign(Object.assign({}, prevState), { uploadProgress: copy })));
    };
    const failed = filename => {
        const copy = state.uploadProgress;
        copy[filename] = { state: 'error', percentage: 100 };
        setState(prevState => (Object.assign(Object.assign({}, prevState), { uploadProgress: copy })));
    };
    const onUploadProgress = (progressEvent) => {
        // Do whatever you want with the native progress event
        //console.log('onUploadProgress', progressEvent)
    };
    const uploadFiles = () => __awaiter(void 0, void 0, void 0, function* () {
        const files = [];
        const filenames = [];
        state.files.forEach((file) => __awaiter(void 0, void 0, void 0, function* () {
            const copy = state.uploadProgress;
            if (copy[file.name] === undefined) {
                copy[file.name] = { state: 'pending', percentage: 0 };
                setState(prevState => (Object.assign(Object.assign({}, prevState), { uploadProgress: copy, uploading: true })));
                const formData = new FormData();
                formData.append('file', file);
                try {
                    files.push(network.postFileToServer(companyId, formData, state.fileCategory, onUploadProgress, userId, orderId));
                }
                catch (error) {
                    console.error('failed to upload file', error);
                }
                filenames.push(file.name);
            }
        }));
        yield Promise.all(files.map((file, index) => __awaiter(void 0, void 0, void 0, function* () {
            const filename = filenames[index];
            file.then(httpResponse => {
                if (httpResponse.status === 200) {
                    onFileAdded(filename, httpResponse.data);
                    done(filename);
                }
                else {
                    failed(filename);
                }
            });
            file.catch(error => {
                failed(filename);
            });
        })));
    });
    const renderProgress = filename => {
        if (state.uploadProgress[filename]) {
            return (React.createElement(ProgressContainer, { deleteFile: deleteFile, filename: filename, onUploadProgress: onUploadProgress, successfullUploaded: state.successfullUploaded, uploading: state.uploading, uploadProgress: state.uploadProgress[filename] }));
        }
    };
    const blurHandler = () => {
        if (state.fileCategory === 'Choose') {
            setFieldValue(currentValue => (Object.assign(Object.assign({}, currentValue), { hasError: true })));
        }
        else {
            setFieldValue(currentValue => (Object.assign(Object.assign({}, currentValue), { hasError: false })));
        }
    };
    const classes = useStyles();
    return (React.createElement("div", { className: submitError ? 'Upload--hasError' : 'Upload' },
        React.createElement("div", { className: "Content" },
            useFileCategorySelector && (React.createElement(FormControl, { variant: "outlined", className: classes.formControl },
                React.createElement(TextField, { select: true, margin: "none", variant: "outlined", value: state.fileCategory, label: intl.formatMessage({ id: 'common.category' }), onBlur: blurHandler, error: fieldValue.hasError === true, onChange: (event) => setState(prevState => (Object.assign(Object.assign({}, prevState), { fileCategory: event.target.value }))), inputProps: {
                        name: 'fileCategory',
                        id: 'fileCategory-helper'
                    } }, FILE_CATEGORIES.map(category => (React.createElement(MenuItem, { key: category.value, value: category.value }, category.label)))),
                React.createElement(FormHelperText, null, intl.formatMessage({ id: 'common.categoryHelpText' })))),
            React.createElement(Dropzone, { files: state.files, onFilesAdded: onFilesAdded, submitError: submitError, disabled: state.fileCategory === 'Choose' }),
            React.createElement("div", { className: "Files" }, state.files.map(file => {
                return (React.createElement("div", { key: file.name, className: classes.row },
                    React.createElement("span", { className: classes.fileName }, file.name),
                    renderProgress(file.name)));
            })))));
});
export default Upload;
